import React from 'react';
import { Dropdown, Button, Tag } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import { useModel } from '../contexts/ModelContext';

function ModelSelector() {
  const { models, selectedModel, changeModel } = useModel();

  // Hide only when we genuinely have nothing to show. ModelContext keeps
  // the previous list around during silent refreshes so the selector
  // doesn't blink out after a config save.
  if (models.length === 0) {
    return null;
  }

  const currentModel = models.find(m => m.key === selectedModel);

  const getModelBorderColor = (costMultiplier) => {
    if (!costMultiplier || costMultiplier <= 1) return '#52c41a';
    if (costMultiplier <= 3) return '#1890ff';
    return '#722ed1';
  };

  const borderColor = getModelBorderColor(currentModel?.cost_multiplier);

  const menuItems = models.map(m => ({
    key: m.key,
    label: (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, minWidth: 280 }}>
        <div>
          <div style={{ fontWeight: selectedModel === m.key ? 700 : 500 }}>
            {m.label || m.display_name}
          </div>
          <div style={{ fontSize: 11, color: '#888' }}>{m.description}</div>
        </div>
        <Tag
          color={m.cost_multiplier <= 1 ? 'green' : m.cost_multiplier <= 3 ? 'blue' : 'purple'}
          style={{ margin: 0 }}
        >
          Token Cost {m.cost_multiplier}x
        </Tag>
      </div>
    ),
    onClick: () => changeModel(m.key),
  }));

  return (
    <Dropdown
      menu={{ items: menuItems, selectedKeys: [selectedModel] }}
      trigger={['click']}
      placement="bottom"
    >
      <Button
        style={{
          borderRadius: 20,
          fontSize: 14,
          height: 36,
          padding: '0 16px',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          background: 'var(--theme-contentBg)',
          border: `2px solid ${borderColor}`,
          color: 'var(--theme-textPrimary, #333)',
          fontWeight: 500,
          boxShadow: `0 0 0 3px ${borderColor}22`,
        }}
      >
        <ThunderboltOutlined style={{ fontSize: 15, color: borderColor }} />
        {currentModel?.label || currentModel?.display_name || 'Select Model'}
        <span style={{ fontSize: 11, color: '#888', marginLeft: 2 }}>▾</span>
      </Button>
    </Dropdown>
  );
}

export default ModelSelector;
